// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Form } from './form';
import { redirect } from '../form-redirect';

/**
 * @class Jsw.form.RestorePassword
 * @extends Jsw.form.Form
 */
export const RestorePassword = Class.create(Form, {
    _initComponentElement($super) {
        $super();

        const content = '' +
            '<input type="hidden" name="cmd" value="update">' +
            '<div id="restorePasswordSection">' +
                '<div id="restorePasswordSection-content-area">' +
                    `<div id="restorePasswordSection-title"><h3>${this.lmsg('title')}&nbsp;</h3></div>` +

                    '<div id="restorePasswordSection-login-name-form-row" class="form-row">' +
                        `<div class="field-name"><label for="restorePasswordSection-login-name">${this.lmsg('loginNameLabel')}&nbsp;</label></div>` +
                        '<div class="field-value">' +
                            `<input type="text" name="login_name" id="restorePasswordSection-login-name" value="${
                                this._getConfigParam('loginNameValue', '')
                            }" class="input-text" />` +
                        '</div>' +
                    '</div>' +

                    '<div id="restorePasswordSection-secret-key-form-row" class="form-row">' +
                        `<div class="field-name"><label for="restorePasswordSection-secret-key">${this.lmsg('secretKeyLabel')}&nbsp;</label></div>` +
                        '<div class="field-value">' +
                            `<input type="text" name="secret" id="restorePasswordSection-secret-key" value="${
                                this._getConfigParam('secretKeyValue', '')
                            }" class="input-text" />` +
                        '</div>' +
                    '</div>' +

                    '<div id="restorePasswordSection-password-form-row" class="form-row">' +
                        `<div class="field-name"><label for="restorePasswordSection-password">${this.lmsg('passwordLabel')}&nbsp;</label></div>` +
                        '<div class="field-value">' +
                            '<input type="password" name="password" id="restorePasswordSection-password" value="" class="input-text" maxlength="255" />' +
                        '</div>' +
                    '</div>' +

                    '<div id="restorePasswordSection-confirm-password-form-row" class="form-row">' +
                        `<div class="field-name"><label for="restorePasswordSection-confirm-password">${this.lmsg('confirmPasswordLabel')}&nbsp;</label></div>` +
                        '<div class="field-value">' +
                            '<input type="password" name="confirm" id="restorePasswordSection-confirm-password" value="" class="input-text" maxlength="255" />' +
                        '</div>' +
                    '</div>' +

                '</div>' +
            '</div>' +

            '<div class="btns-box">' +
                '<div class="box-area">' +
                    '<div class="form-row">' +
                        '<div class="field-value">' +
                            '<span id="btn-restore" class="btn action">' +
                                `<button id="restorePasswordSection-button-restore" type="submit" value="" name="send">${this.lmsg('buttonRestore')}</button>` +
                            '</span>' +
                            '<span id="btn-cancel" class="btn">' +
                                `<button id="restorePasswordSection-button-cancel" type="button" value="" name="cancel">${this.lmsg('buttonCancel')}</button>` +
                            '</span>' +
                        '</div>' +
                        '<input type="image" src="/theme/images/blank.gif" style="border: 0; height: 0; width: 0; position: absolute; left: -9999px;"/>' +
                    '</div>' +
                '</div>' +
            '</div>';

        this._componentElement.update(this._getConfigParam('warnings', '') + content);
        this._componentElement.down('#restorePasswordSection-login-name').focus();
        this._componentElement.down('#restorePasswordSection-login-name').select();

        this._componentElement.down('#restorePasswordSection-button-cancel').observe('click', function () {
            redirect('/login_up.php');
        });
    },

    _onSubmit($super) {
        const isError = $('restorePasswordSection-login-name', 'restorePasswordSection-secret-key', 'restorePasswordSection-password', 'restorePasswordSection-confirm-password')
            .some(function (element) {
                if (element.value === '') {
                    element.focus();
                    element.select();
                    return true;
                }
                return false;
            });

        if (isError) {
            // eslint-disable-next-line no-alert
            alert(this.lmsg('enterAllRequiredElement'));
            return;
        }

        const confirmPassword = $('restorePasswordSection-confirm-password');
        if ($('restorePasswordSection-password').value !== confirmPassword.value) {
            // eslint-disable-next-line no-alert
            alert(this.lmsg('passwordDoesntMatch'));
            confirmPassword.focus();
            confirmPassword.select();
            return;
        }

        $super();
    },
});



// WEBPACK FOOTER //
// ./jsw/form/restore-password.js